export const TOOLTIP_MESSAGES = {
  initialFormValue:
    "This amount is calculated from other fields in your loan origination system, and must be edited within that application.",
};
